import React from 'react';
import {NavLink, useNavigate} from "react-router-dom";
import {LuDatabaseBackup, LuLayoutDashboard} from "react-icons/lu";
import {RiListCheck3, RiVerifiedBadgeLine} from "react-icons/ri";
import API from "../Services/API";
import {toast} from "react-toastify";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {TbTruckDelivery} from "react-icons/tb";
import {GrScheduleNew} from "react-icons/gr";
import {SiSearxng} from "react-icons/si";
import {HiOutlineUserGroup} from "react-icons/hi";
import {GiTwoCoins} from "react-icons/gi";

const Navbar = (props) => {
    const navigate = useNavigate();


    const [orders, setOrders] = React.useState([]);
    const [permissions, setPermissions] = React.useState([]);

    React.useEffect(() => {

        const thePermissions = window.localStorage.getItem("spr");

        if (!thePermissions) {
            navigate('/');
        }
        else {
            const jPermissions = JSON.parse(thePermissions)
            setPermissions(jPermissions)

            if(jPermissions[props.page] !== 1 && props.public !== "1") {
                toast.error('دسترسی غیر مجاز');
                setTimeout (() => {
                    window.history.back()
                },400)
            }
        }

        let params = {
            count: 40,
            page: 1,
            list: 1,
            processFor: 'Sales',
            status_id:  1,
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);


            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

    }, [props.page]);

    return (
        <React.Fragment>
            <aside id="sidebar" className="sidebar rtl">

                <ul className="sidebar-nav" id="sidebar-nav">

                    {
                        permissions.dashboard > 0 &&
                    <li className="nav-item">
                        <NavLink to='/home'
                                 className={props.page === 'dashboard' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuLayoutDashboard className='ms-2 nav-icon' />
                            <span>داشبورد</span>
                        </NavLink>
                    </li>
                    }


                    {
                        permissions.new > 0 &&
                    <li className="nav-item">
                        <NavLink to='/orders-list/1'
                                 className={props.page === 'new' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GrScheduleNew  className='ms-2 nav-icon' />
                            <span>سفارش های جدید</span>
                            {orders.length > 0 &&
                            <span className="badge  bg-primary-color me-2"> {orders.length}</span>
                            }
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.verified > 0 &&
                    <li className="nav-item">
                        <NavLink to='/orders-list/13'
                                 className={props.page === 'verified' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <RiVerifiedBadgeLine  className='ms-2 nav-icon' />
                            <span>سفارش های تایید شده</span>


                        </NavLink>
                    </li>
                    }


                    {
                        permissions.load > 0 &&
                    <li className="nav-item">
                        <NavLink to='/orders-list/17'
                                 className={props.page === 'load' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbTruckDelivery  className='ms-2 nav-icon' />
                            <span>سفارش های انبار</span>


                        </NavLink>
                    </li>
                    }


                    {
                        permissions.orders > 0 &&
                    <li className="nav-item">
                        <NavLink to='/orders'
                                 className={props.page === 'orders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <RiListCheck3  className='ms-2 nav-icon' />
                            <span>تاریخچه سفارش ها  </span>
                        </NavLink>
                    </li>
                    }


                    <li className="nav-item">
                        <hr/>
                    </li>

                    {
                        permissions.battery > 0 &&
                    <li className="nav-item">
                        <NavLink to='/search'
                                 className={props.page === 'battery' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <SiSearxng  className='ms-2 nav-icon' />
                            <span>
                                جستجوی باتری
                            </span>


                        </NavLink>
                    </li>
                    }

                    <li className="nav-item">
                        <hr/>
                    </li>

                    {
                        permissions.vendors > 0 &&
                    <li className="nav-item">
                        <NavLink to='/vendors'
                                 className={props.page === 'vendors' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <HiOutlineUserGroup  className='ms-2 nav-icon' />
                            <span>
                                مدیریت نمایندگان
                            </span>

                        </NavLink>
                    </li>
                    }

                    {
                        permissions.vendorOrders > 0 &&
                    <li className="nav-item">
                        <NavLink to='/order-create'
                                 className={props.page === 'vendorOrders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <AiOutlineAppstoreAdd  className='ms-2 nav-icon' />
                            <span>ثبت سفارش از طرف نماینده</span>


                        </NavLink>
                    </li>
                    }

                    {
                        permissions.reports > 0 &&
                    <li className="nav-item">
                        <NavLink to='/vendors-reports'
                                 className={props.page === 'reports' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GiTwoCoins  className='ms-2 nav-icon' />
                            <span>گزارش عملکرد نمایندگان</span>


                        </NavLink>
                    </li>
                    }
                    <li className="nav-item">
                        <hr/>
                    </li>
                    {
                        permissions.returns > 0 &&
                    <li className="nav-item">
                        <NavLink to='/return-orders'
                                 className={props.page === 'returns' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <RiListCheck3  className='ms-2 nav-icon' />
                            <span> سفارش های مرجوعی  </span>
                        </NavLink>
                    </li>
                    }
                    <li className="nav-item">
                        <hr/>
                    </li>
                    {
                        permissions.sb > 0 &&
                        <li className="nav-item">
                            <NavLink to='/sb-orders'
                                     className={props.page === 'sb' ? "nav-link" : "nav-link collapsed"}
                                     role="button"
                            >
                                <LuDatabaseBackup className='ms-2 nav-icon'/>
                                <span>  سفارش های  برگشت از فروش  </span>
                            </NavLink>
                        </li>
                    }
                </ul>

            </aside>
        </React.Fragment>
    );
};

export default Navbar;
